export interface PartnersState {
    partners:PartnerItem[]
    partnerItem?:PartnerItem
}

export interface PartnerItem {
    id?:number,
    name:string,
    status:number,
    prepaid: boolean,
    transport_names: string[],
    transports?:PartnerTransportItem[]
}

export class PartnerFilter {
    id?:number;
    name?: string;
    transport?: string[];
    status?: number;
    prepaid?: boolean;
    page_number: number = 1;
}

export interface PartnerTransportItem {
    id:number,
    name?:string,
    multisignature:boolean,
    template_only:boolean,
    on_moderation:boolean
}

export class PartnerItemImpl implements PartnerItem{
    name: string;
    status: number;
    transports: PartnerTransportItem[];
    prepaid: boolean;
    transport_names: string[];

    constructor() {
        this.name = '';
        this.status = 0;
        this.transports = [];
        this.prepaid = false;
        this.transport_names = [];
    }
}

